
export function resizeDsyTableSortIcons(size = '16px'): void {
  document.querySelectorAll('dsy-table').forEach(table => {
    table.shadowRoot
      ?.querySelectorAll('dsy-icon[name="swap_vert"]')
      .forEach(icon => {
        const base = icon.shadowRoot?.querySelector('[part="base"]') as HTMLElement;

        if (base) {
          base.style.width = size;
          base.style.height = size;
        }
      });
  });
}
